import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff3aa6f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cutom-margin-bottom" }, null, -1))
const _hoisted_3 = { class: "p-mt-3 footer-9 p-px-2" }
const _hoisted_4 = { class: "p-d-flex p-jc-between p-my-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคาสุทธิ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionHeader = _resolveComponent("TransactionHeader")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.transaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_TransactionHeader, {
            transactionInvoice: _ctx.transaction.invoiceNo,
            statusId: _ctx.transaction.statusId.toString(),
            statusName: _ctx.transaction.statusName,
            tittle: 'หมายเลขคำสั่งซื้อ',
            isDisplayInvoice: true
          }, null, 8, ["transactionInvoice", "statusId", "statusName"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionCartDetail, {
        transaction: _ctx.transaction,
        isShowCart: false
      }, null, 8, ["transaction"])
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)), 1)
      ]),
      _createVNode(_component_Button, {
        class: "bg-black w-100",
        label: "ยืนยัน",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit()))
      })
    ])
  ]))
}